import { Helmet } from 'react-helmet-async';
import SubscriptionProvider from './provider';
import Header from './header';
import Body from './body';
import SubscriptionFilterSidebar from './filter';

const SubscriptionPage = () => {
  return (
    <SubscriptionProvider>
      <>
        <Helmet>
          <title> Subscriptions </title>
        </Helmet>
        <Header />
        <Body />
        <SubscriptionFilterSidebar />
      </>
    </SubscriptionProvider>
  );
};

export default SubscriptionPage;
